import React from 'react';
import { FileUploadDiv, helperText } from '../../assets/theme/Theme';
import {
	Grid,
	Typography,
	IconButton as IconBtn,
	Tooltip,
	TextField,
	TableContainer,
	Table,
	TableRow,
	TableCell,
	TableBody,
	Button,
} from '@mui/material';
import {
	ConnectAPi,
	SmallEyeIcon,
	UploadFile,
	UploadIcon,
} from '../../assets/icons/Icons';
import IconButton from '../../components/IconButton';
import 'react-toastify/dist/ReactToastify.css';
import { TOOLTIPS } from '../../Utils/Enums';
import FileContentTile from '../../components/FileContentTile';
import Dropzone from 'react-dropzone';

function AddInitialCarePlan({
	onUploadPlan,
	connectApiState = false,
	isConnectApiEnabled,
	elderIdDropDown,
	onShowFileUpload,
	instruction,
	onChangeInstruction,
	onGeneratePlan,
	residentProfiles,
	files,
	onRemoveFiles,
	txtError,
	readTextFile,
	onChangeProfile,
	onSaveChange,
	onClearChange,
	isProfileEdited,
}) {
	function formatValue(value) {
		if (
			!value ||
			(typeof value === 'string' && !value.trim()) ||
			(Array.isArray(value) && !value.length) ||
			(value &&
				typeof value === 'object' &&
				!Array.isArray(value) &&
				!Object.keys(value).length)
		) {
			return (
				<Typography fontSize="14px" color="#777">
					Not Mentioned
				</Typography>
			);
		}

		if (Array.isArray(value)) {
			return value.map((item, i) => (
				<div key={i}>{formatValue(item)}</div>
			));
		} else if (value && typeof value === 'object') {
			return (
				<Grid container spacing={1} marginTop={'1px'}>
					{Object.entries(value).map(([k, v]) => (
						<Grid key={k} item xs={12}>
							<Typography variant="body2" fontWeight="bold">
								{k}:
							</Typography>
							<div>{formatValue(v)}</div>
						</Grid>
					))}
				</Grid>
			);
		}

		return (
			<Typography fontSize="14px" color="#000">
				{value}
			</Typography>
		);
	}

	const textFieldStyle = {
		'& .MuiOutlinedInput-root': {
			fontSize: '14px',
			height: '40px',
			// Hide border by default
			'& fieldset': {
				border: 'none',
			},
			// Show border only on hover
			'&:hover fieldset': {
				border: '1px solid #e0e0e0',
			},
			// Keep focus border visible
			'&.Mui-focused fieldset': {
				border: '2px solid #1976d2', // or your preferred focus color
			},
		},
	};

	return (
		<>
			<Grid
				container
				marginLeft={'20px'}
				paddingX={'20px'}
				bgcolor={'#FFFFFF'}
				marginRight={'20px'}
				borderRadius={'10px'}
				paddingBottom={'10px'}>
				<Grid container flexDirection={'row'}>
					<Grid
						container
						flexDirection={'row'}
						alignItems={'center'}
						paddingTop={'20px'}>
						<Typography
							fontSize={'16px'}
							color={'#7C7C7C'}
							paddingRight={'10px'}>
							Elder ID
						</Typography>
						<Tooltip
							title={TOOLTIPS.initialCarePlan.elderId}
							placement="right"
							arrow>
							<Typography paddingTop={'5px'}>
								<SmallEyeIcon />
							</Typography>
						</Tooltip>
					</Grid>
				</Grid>
				{elderIdDropDown}
				{onShowFileUpload && (
					<>
						<Grid container spacing={1} marginY={'15px'}>
							<Typography
								width={'100%'}
								fontSize={'16px'}
								fontWeight={'600'}
								paddingBottom={'5px'}
								marginLeft={'8px'}
								color={'#7C7C7C'}>
								Resident Profile
							</Typography>
							{residentProfiles &&
								Object.keys(residentProfiles).length > 0 && (
									<TableContainer
										sx={{
											borderRadius: '5px',
											border: '1px solid #e0e0e0',
											marginY: '5px',
											overflow: 'hidden',
											marginLeft: '8px',
										}}>
										<Table>
											<TableBody>
												{Object.entries(
													residentProfiles,
												).map(([key, value]) => {
													const finalKey = key
														.split('.')
														.pop();
													const displayKey =
														finalKey
															.charAt(0)
															.toUpperCase() +
														finalKey.slice(1);

													return (
														<TableRow key={key}>
															<TableCell
																sx={{
																	fontWeight: 500,
																	color: '#28696D',
																	py: 2,
																	width: '25%',
																}}>
																{displayKey}
															</TableCell>
															<TableCell
																sx={{
																	py: 2,
																}}>
																<TextField
																	fullWidth
																	sx={
																		textFieldStyle
																	}
																	value={
																		value
																	}
																	disabled={
																		key ===
																		'elderId'
																	}
																	onChange={e =>
																		onChangeProfile(
																			e,
																			key,
																		)
																	}
																	placeholder="Edit"
																/>
															</TableCell>
														</TableRow>
													);
												})}
											</TableBody>
										</Table>
									</TableContainer>
								)}
							<Grid
								container
								sx={{
									justifyContent: 'flex-end',
									marginTop: '5px',
								}}>
								<Button
									variant="contained"
									style={{
										backgroundColor: '#FFFFFF',
										boxShadow: 'none',
										textTransform: 'none',
										fontSize: '14px',
										fontWeight: '400',
										marginLeft: '5px',
										color: '#28696D',
										marginRight: '5px',
										border: '1px solid #28696D',
									}}
									onClick={onClearChange}>
									Reset
								</Button>
								<IconButton
									disabled={!isProfileEdited}
									text={'Save'}
									onClick={onSaveChange}
								/>
							</Grid>
						</Grid>
						<Typography
							fontSize={'16px'}
							fontWeight={'600'}
							paddingBottom={'5px'}
							color={'#7C7C7C'}>
							File Upload
						</Typography>
						<Dropzone
							onDrop={acceptedFiles =>
								readTextFile(acceptedFiles)
							}>
							{({ getRootProps, getInputProps }) => (
								<section style={{ width: '100%' }}>
									<div
										{...getRootProps()}
										style={{
											...FileUploadDiv,
											border: txtError?.status
												? '1px dashed red'
												: FileUploadDiv.border,
										}}>
										<input {...getInputProps()} />
										<UploadIcon />
										<br />
										<>
											<Typography
												fontSize={'16px'}
												fontWeight={'700'}
												marginTop={'5px'}
												color={'#7C7C7C'}>
												{
													TOOLTIPS.initialCarePlan
														.uploadFile
												}
											</Typography>
											<Typography
												fontSize={'14px'}
												color={'#B4B2B2'}>
												Maximum upload file size: 5MB
											</Typography>
										</>
									</div>
								</section>
							)}
						</Dropzone>
						<Typography sx={helperText}>{txtError.msg}</Typography>
						{files && files.length > 0 && (
							<Grid
								container
								flexDirection={'column'}
								marginTop={'15px'}>
								<Grid container alignItems="center" spacing={2}>
									{files.map((item, index) => {
										return (
											<Grid
												item
												xs={6}
												sm={4}
												md={3}
												key={index}>
												<FileContentTile
													key={index}
													file={item}
													onRemoveFiles={
														onRemoveFiles
													}
												/>
											</Grid>
										);
									})}
								</Grid>
							</Grid>
						)}
						<Grid container paddingTop={'15px'}>
							<Typography
								fontSize={'16px'}
								fontWeight={'600'}
								paddingBottom={'5px'}
								color={'#7C7C7C'}>
								Instructions
							</Typography>
							<Grid
								border={'1px solid #D9D9D9'}
								bgcolor={'#FFFFFF'}
								borderRadius={'5px 0px 0px 5px'}
								width={'100%'}>
								<TextField
									placeholder="Mention the specific instructions or considerations to be used during care plan generation."
									multiline
									sx={{
										'& fieldset': {
											border: 'none',
										},
										width: '100%',
										'&::placeholder': {
											fontSize: '14px',
										},
									}}
									onChange={e =>
										onChangeInstruction(e.target.value)
									}
									value={instruction}
									rows={6}
								/>
							</Grid>
							<Grid
								container
								width={'100%'}
								justifyContent={'flex-end'}
								alignItems={'center'}
								paddingY={'10px'}>
								<IconButton
									text={'Generate Plan'}
									onClick={onGeneratePlan}
								/>
							</Grid>
						</Grid>
					</>
				)}
			</Grid>
			<Grid
				container
				marginLeft={'20px'}
				paddingRight={'20px'}
				paddingY={'10px'}
				display={'none'}
				style={
					isConnectApiEnabled
						? {
								filter: 'blur(0.8px)',
								pointerEvents: 'none',
							}
						: {}
				}>
				<IconBtn
					disableRipple
					// onClick={() => onClickFirstBtn('API')}
					style={{
						backgroundColor: 'transparent',
						padding: '0px',
						width: '100%',
					}}>
					<Grid
						container
						height={'130px'}
						padding={'10px'}
						borderRadius={'15px'}
						bgcolor={connectApiState ? '#28696D' : '#FFFFFF'}
						justifyContent={'center'}
						alignItems={'center'}>
						<ConnectAPi />
						<Typography
							variant="h6"
							marginLeft={'10px'}
							fontWeight={'500'}
							color={connectApiState ? '#FFFFFF' : '#28696D'}>
							Connect Your Api
						</Typography>
					</Grid>
				</IconBtn>
			</Grid>
		</>
	);
}

export default AddInitialCarePlan;
